import React from 'react';

const ShieldIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.66927 10.0017H6.6776M10.0026 10.0017H10.0109M13.3359 10.0017H13.3443M16.6693 10.835C16.6693 15.0017 13.7526 17.085 10.2859 18.2933C10.1044 18.3549 9.90722 18.3519 9.7276 18.285C6.2526 17.085 3.33594 15.0017 3.33594 10.835V5.00168C3.33594 4.78066 3.42374 4.5687 3.58002 4.41242C3.7363 4.25614 3.94826 4.16834 4.16927 4.16834C5.83594 4.16834 7.91927 3.16834 9.36927 1.90168C9.54582 1.75084 9.7704 1.66797 10.0026 1.66797C10.2348 1.66797 10.4594 1.75084 10.6359 1.90168C12.0943 3.17668 14.1693 4.16834 15.8359 4.16834C16.057 4.16834 16.2689 4.25614 16.4252 4.41242C16.5815 4.5687 16.6693 4.78066 16.6693 5.00168V10.835Z'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ShieldIcon;
